module.exports = __webpack_public_path__ + "static/images/opportunities-fill.06f145524efbf8230d93108b370fa60f.svg";